import React from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
const HeaderComponent: React.FC = () => {
  const isLoggedIn = localStorage.getItem("accessToken");
  const navigate = useNavigate();

  const handleLogout = async () => {
    localStorage.removeItem("accessToken");
    navigate("/login");
    window.location.reload();
  };
  return (
    <div className="header">
      <div className="center_logo">
        <img className="logo" src="./uet_logo.png" alt="logo" />
        <img className="logo_title" src="./dhcn.png" alt="Đại Học Công Nghệ" />
        <h1 className="searchTitle">
          Tra cứu thông tin kỳ thi Olympic bậc THPT của ĐHQGHN{" "}
        </h1>
        <h3 className="searchTitle">
          Năm học 2024-2025 các môn Toán, Tin học, Vật lí, Hoá học, Sinh học
        </h3>
        {isLoggedIn && (
          <button className="logout-btn" onClick={handleLogout}>
            Đăng xuất
          </button>
        )}
      </div>
    </div>
  );
};

export default HeaderComponent;
